import InfoIcon from '@mui/icons-material/Info'
import { Stack, Typography } from '@mui/material'

import Space from 'components/Space'
import { HintProps } from './types'

export const Hint = ({ content, contentEndAdornment, ...stackProps }: HintProps): JSX.Element => (
  <Stack
    {...stackProps}
    data-cy='hint'
    direction='row'
    sx={{
      alignItems: 'center',
      gap: 1,
      p: 1,
      ...stackProps.sx,
    }}
  >
    <InfoIcon
      data-cy='info-icon'
      sx={{ color: theme => theme.palette.grey[400] }}
    />
    <Typography variant='subtitle1'>
      {content}

      {contentEndAdornment && (
        <>
          <Space />
          {contentEndAdornment}
        </>
      )}
    </Typography>
  </Stack>
)
